import React from 'react';
import { Box, Typography, Button, TextField, Grid, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export const Needles = ({ value = [], onChange, editMode = false }) => {
  if (editMode) {
    const handleAddNeedle = () => {
      const newNeedles = [...value, { size: '', type: '' }];
      onChange('needles', newNeedles);
    };

    const handleChange = (index, field, fieldValue) => {
      const newNeedles = [...value];
      newNeedles[index] = { ...newNeedles[index], [field]: fieldValue };
      onChange('needles', newNeedles);
    };

    const handleRemove = (index) => {
      const newNeedles = value.filter((_, i) => i !== index);
      onChange('needles', newNeedles);
    };

    return (
      <Box my={2}>
        <Typography variant="h6" gutterBottom>Needles</Typography>
        {value.map((needle, index) => (
            <Grid key={index} container spacing={1}>
              <Grid size={5}>
                <TextField
                  label="Size"
                  value={needle.size || ''}
                  onChange={(e) => handleChange(index, 'size', e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>
              <Grid size={5}>
                <TextField
                  label="Type"
                  value={needle.type || ''}
                  onChange={(e) => handleChange(index, 'type', e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>
              <Grid size={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <IconButton
                  color="error"
                  onClick={() => handleRemove(index)}
                  size="small"
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
        ))}
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAddNeedle}
          sx={{ mt: 1 }}
        >
          Add Needle
        </Button>
      </Box>
    );
  }

  return (<>
    {value.map((needle, index) => (
      <Typography key={index}>
        {needle.size} {needle.type} needles or size needed to obtain gauge
      </Typography>
    ))}
  </>);
};

export default Needles;
